(function () {
  const config = window.KARTOLOG_PRODUCT_VIEW;
  if (!config || !config.productId || !config.endpoint) return;

  const key = `kartolog:view:${config.productId}`;
  const now = Date.now();
  const ttl = 30 * 60 * 1000;

  try {
    const last = Number(sessionStorage.getItem(key) || 0);
    if (last && now - last < ttl) return;
    sessionStorage.setItem(key, String(now));
  } catch {
    // sessionStorage can be unavailable in private contexts; tracking should still try once.
  }

  const payload = JSON.stringify({
    productId: config.productId,
    handle: config.handle || '',
    title: config.title || '',
    path: window.location.pathname,
  });

  if (navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' });
    if (navigator.sendBeacon(config.endpoint, blob)) return;
  }

  fetch(config.endpoint, {
    method: 'POST',
    mode: 'cors',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: payload,
  }).catch(() => {});
})();
